/**
 * Concats a template literal and interpolates values correctly, as well as removes formatting whitespace and HTML comments
 */
function html(strings, ...interpolations) {
  let str = strings[0]
  for (let i = 0; i < interpolations.length; i++) {
    str += interpolations[i]
    str += strings[i + 1]
  }

  return str.replace(/>\s+</g, '><').replace(/<!--(.|\s)*?-->/, '')
}

module.exports.html = html
